import { DatabasesExternalAssetsDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { Action } from 'redux';

import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { UngroupDatabases } from '../AppActionTypes';

export type DatabaseForUngrouping =
  IExplorableItemTypeInfo<'database' | 'databaseWithCrass'> &
  Pick<DatabasesExternalAssetsDisplayGridRowData, 'name' | 'luid' | 'isGrouped'>;

export interface UngroupDatabasesAction extends Action {
  readonly database: DatabaseForUngrouping;
}

export function ungroupDatabasesAction(database: DatabaseForUngrouping): UngroupDatabasesAction {
  return {
    type: UngroupDatabases,
    database
  };
}
